import React, { useState, useEffect, useContext } from "react";
import { API_URL } from "../../components/api";
import "bootstrap/dist/css/bootstrap.css";
import Axios from "axios";
import AuthContext from "../../context/AuthContext";

function EditInvoice(props) {
  function refreshPage() {
    window.location.reload(false);
  }

  const [message, setMessage] = useState(null);

  let { user } = useContext(AuthContext);
  const { order_id, invoice_id } = props;
  let authTokens = JSON.parse(localStorage.getItem("authTokens"));
  const [discount, setDiscount] = useState(
    Number(props.discount) || 0
  );
  const [originalProductTotal, setOriginalProductTotal] =
    useState(0);
  const [note, setNote] = useState(props.note || "");
  const [items, setItems] = useState([]);

  const [cat, setCat] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      const params = { username: user.username };
      let url;
      if (order_id) {
        url = `${API_URL}/inventory/order/details/`;
        params.order_id = order_id;
      } else if (invoice_id) {
        url = `${API_URL}/inventory/invoice/details/`;
        params.invoice_id = invoice_id;
      } else {
        return;
      }

      try {
        const resp = await Axios.get(url, {
          headers: { Authorization: `Bearer ${authTokens.access}` },
          params,
        });
        if (resp.status === 200 && isMounted) {
          setItems(resp.data);
          setCat(resp.data);
          setDiscount(Number(props.discount) || 0);
          setNote(props.note || "");
          setOriginalProductTotal(
            resp.data.reduce((sum, item) => {
              const itemType = String(
                item.item_type
              ).toLowerCase();

              const price = item.is_free
                ? 0
                : itemType === "product"
                ? Number(item.product_selling) || 0
                : Number(item.service_selling) || 0;

              return (
                sum +
                price * (Number(item.quantity) || 0)
              );
            }, 0)
          );
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchData();
    return () => {
      isMounted = false;
    };
  }, [order_id, invoice_id, user.username, authTokens.access]);

  const showMessage = (message, type = "success") => {
    setMessage({ text: message, type });

    // Close the modal after 3 seconds
    setTimeout(() => {
      refreshPage();
    }, 1200);

    // Clear the message after 5 seconds
    setTimeout(() => {
      setMessage(null);
    }, 1000);
  };

  const currentProductTotal = cat.reduce(
    (sum, item) => {
      const itemType = String(
        item.item_type
      ).toLowerCase();

      const price = item.is_free
        ? 0
        : itemType === "product"
        ? Number(item.product_selling) || 0
        : Number(item.service_selling) || 0;

      return (
        sum + price * (Number(item.quantity) || 0)
      );
    },
    0
  );

  const total = Math.max(
    0,
    (Number(props.total_amount) || 0) -
      originalProductTotal +
      currentProductTotal
  );

  const totalWithDiscount = Math.max(
    0,
    total - discount
  );

  const handleQuantityChange = (index, value) => {
    setCat((currentItems) =>
      currentItems.map((item, itemIndex) =>
        itemIndex === index
          ? {
              ...item,
              quantity:
                value === ""
                  ? ""
                  : Math.max(
                      1,
                      parseInt(value, 10) || 1
                    ),
            }
          : item
      )
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const invoiceItems = cat.map((item) => ({
      entry_id: item.entry_id,
      quantity: Number(item.quantity),
    }));

    if (
      invoiceItems.some(
        (item) =>
          !item.entry_id ||
          !Number.isInteger(item.quantity) ||
          item.quantity < 1
      )
    ) {
      showMessage(
        "Every item quantity must be at least 1.",
        "danger"
      );
      return;
    }

    if (discount < 0 || discount > total) {
      showMessage(
        "Discount cannot exceed the invoice total.",
        "danger"
      );
      return;
    }

    const submitData = {
      Action: "Put",
      order: props.order_id,
      invoice_id: props.invoice_id,
      discount,
      note,
      items: invoiceItems,
      userdealer: user.username,
    };

    try {
      await Axios.post(
        `${API_URL}/inventory/invoices/`,
        submitData,
        {
          headers: {
            Authorization:
              `Bearer ${authTokens.access}`,
          },
        }
      );

      showMessage(
        "Invoice edited successfully!",
        "success"
      );
    } catch (error) {
      console.log(error);
      showMessage(
        error.response?.data?.error ||
          "Invoice edit failed!",
        "danger"
      );
    }
  };

  const handleDiscountChange = (e) => {
    const value = e.target.value;
    const parsed = value === "" ? 0 : Number(value);

    if (
      Number.isFinite(parsed) &&
      parsed >= 0
    ) {
      setDiscount(parsed);
    }
  };

  return (
    <div className="testi">
      <div className="mod">
        <form onSubmit={handleSubmit}>
          <table className="table">
            <thead>
              <tr>
                <th>Item Type</th>
                <th>Item Name</th>
                <th>Quantity</th>
                <th>Unit Price</th>
                <th>Total Price</th>
              </tr>
            </thead>
            <tbody>
              {cat.map((item, index) => (
                <tr key={index}>
                  <td>{item.item_type}</td>
                  <td>
                    {item.item_type.toLowerCase() === "product"
                      ? item.product_name
                      : item.service_name}
                  </td>
                  <td>
                    {order_id ? (
                      <input
                        type="number"
                        min="1"
                        step="1"
                        required
                        value={item.quantity}
                        onChange={(event) =>
                          handleQuantityChange(
                            index,
                            event.target.value
                          )
                        }
                        style={{ width: "80px" }}
                      />
                    ) : (
                      item.quantity
                    )}
                  </td>
                  <td>
                    {item.item_type.toLowerCase() === "product"
                      ? `$${parseFloat(item.product_selling).toFixed(2)}`
                      : `$${parseFloat(item.service_selling).toFixed(2)}`}
                  </td>
                  <td>
                    {item.item_type.toLowerCase() === "product"
                      ? `$${(
                          parseFloat(item.product_selling) * item.quantity
                        ).toFixed(2)}`
                      : `$${(
                          parseFloat(item.service_selling) * item.quantity
                        ).toFixed(2)}`}
                  </td>
                </tr>
              ))}
              <tr>
                <td colSpan="4" className="text-right">
                  Total:
                </td>
                <td>{`$${total.toFixed(2)}`}</td>
              </tr>
              <tr>
                <td colSpan="4" className="text-right">
                  Discount:
                </td>
                <td>
                  <input
                    type="number"
                    step="0.1"
                    min="0"
                    max={total.toFixed(2)}
                    value={discount}
                    onChange={handleDiscountChange}
                  />
                </td>
              </tr>
              <tr>
                <td colSpan="4" className="text-right">
                  Total with Discount:
                </td>
                <td>{`$${totalWithDiscount.toFixed(2)}`}</td>
              </tr>
            </tbody>
          </table>
          <textarea
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder={props.note || "Enter note..."}
            rows="3"
            cols="30"
          />
          <div className="fo">
            <button type="submit" className="btn btn-primary btn-md">
              Edit Invoice
            </button>
          </div>
        </form>
      </div>
      {/* Popup Message */}
      {message && (
        <div
          className={`alert alert-${message.type} alert-dismissible fade show`}
          role="alert"
          style={{
            position: "fixed",
            bottom: "10px",
            margin: "10px",
            right: "10px",
            zIndex: "9999",
          }}
        >
          {message.text}
        </div>
      )}
    </div>
  );
}

export default EditInvoice;
